import React, { useState, useEffect } from 'react';
import BlogCard from './BlogCard';
import '../CSS/BlogList.css'; 
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import bgImage from '../assets/bgImage.png'; 

import blog1 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7593.jpg";
import blog2 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7601.jpg"; 
import blog3 from "../assets/LIBRA EVENTS/_DSC9636.jpg";
import blog4 from "../assets/LIBRA EVENTS/_PHP0566.jpg";
import blog5 from "../assets/LIBRA EVENTS/KSH_2988.jpg";
import blog6 from "../assets/LIBRA EVENTS/KSH_2840.jpg";
import blog7 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-02-27 at 3.40.41 PM (3).jpeg";
import blog8 from "../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.44 PM (1).jpeg";
import blog9 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7609.jpg";
import blog10 from "../assets/LIBRA EVENTS/KSH_0591.jpg";
import blog11 from "../assets/LIBRA EVENTS/KSH_2525.jpg";
import blog12 from "../assets/LIBRA EVENTS/DSC_5653.jpg";
import blog13 from "../assets/LIBRA EVENTS/KSH_2562.jpg";
import blog14 from "../assets/LIBRA EVENTS/0O0A4128.jpg";
import blog15 from "../assets/LIBRA EVENTS/_PHP0566.jpg";
import blog16 from "../assets/LIBRA EVENTS/KSH_0929.jpg";
import blog17 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7596.jpg";
import blog18 from "../assets/LIBRA EVENTS/KSH_2988.jpg";
import blog19 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-01-30 at 12.01.21 PM.jpeg";
import blog20 from "../assets/LIBRA EVENTS/KSH_7844.jpg";
import blog21 from "../assets/LIBRA EVENTS/new/IMG-20250822-WA0037.jpg";
import blog22 from "../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.45 PM (1).jpeg";
import blog23 from "../assets/LIBRA EVENTS/KSH_2769.jpg";
import blog24 from "../assets/LIBRA EVENTS/_SDL2382.jpg";
import blog25 from "../assets/LIBRA EVENTS/KSH_1810.jpg";
import blog26 from "../assets/LIBRA EVENTS/_SDL4073.jpg";
import blog27 from "../assets/LIBRA EVENTS/KSH_1689.jpg";
import blog28 from "../assets/LIBRA EVENTS/KSH_4829.jpg";
import blog29 from "../assets/LIBRA EVENTS/zydus 28th feb/KSH_7586.jpg";
import blog30 from "../assets/LIBRA EVENTS/KSH_2988.jpg";
import blog31 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-01-26 at 7.51.18 PM (6).jpeg";
import blog32 from "../assets/LIBRA EVENTS/KSH_0083.jpg";
import blog33 from "../assets/LIBRA EVENTS/WhatsApp Image 2023-12-24 at 7.13.53 PM.jpeg";
import blog34 from "../assets/LIBRA EVENTS/KSH_3271.jpg";
import blog35 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-02-27 at 3.20.39 PM.jpeg";
import blog36 from "../assets/LIBRA EVENTS/KSH_2525.jpg";
import blog37 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-01-29 at 10.41.35 AM.jpeg";
import blog38 from "../assets/LIBRA EVENTS/WhatsApp Image 2024-01-29 at 10.41.31 AM.jpeg";
import blog39 from "../assets/LIBRA EVENTS/KSH_1632.jpg";
import blog40 from "../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.43 PM (2).jpeg";

// Blog post data
const blogPosts = [
  {
  id: 40,
  author: "Libra Events Blog Team",
  date: "21-03-2026",
  title: "Finland Honeymoon From India: A Magical Arctic Love Story",
  slug: "finland-honeymoon-from-india-magical-arctic-love-story",
  image: blog40,
  snippet: "If you’re dreaming of a honeymoon that feels straight out of a fairytale, Finland might just be your perfect destination. From snowy landscapes and glass igloos to the Northern Lights dancing across the sky, Finland offers a once-in-a-lifetime romantic experience for newlyweds."
},
  {
  id: 39,
  author: "Libra Events Blog Team",
  date: "23-02-2026",
  title: "100+ Best Bridal Mehendi Designs for 2026 Brides",
  slug: "100-best-bridal-mehendi-designs-2026-brides",
  image: blog39,
  snippet: "Bridal Mehendi is more than just a pre-wedding ritual — it’s an emotional, artistic, and symbolic celebration of love. In 2026, bridal Mehendi trends are evolving with a mix of traditional elegance and modern creativity."
},

  {
  id: 38,
  author: "Libra Events Blog Team",
  date: "21-02-2026",
  title: "Trending – Thick Floral Braids For Mehndi & Haldis",
  slug: "thick-floral-braids-mehndi-haldi-2026",
  image: blog38,
  snippet: "Move over messy buns — thick floral braids are officially the biggest bridal hair trend for Mehndi and Haldi ceremonies in 2026. From pastel weddings to traditional celebrations, brides are embracing fuller, longer, and flower-loaded braids that look stunning both in real life and on camera."
},

  {
  id: 37,
  author: "Libra Events Blog Team",
  date: "19-02-2025",
  title: "What’s Trending in Bridal Hair Accessories & Hairstyles (2026 Guide)",
  slug: "bridal-hair-accessories-hairstyles-2026-guide",
  image: blog37,
  snippet: "Bridal beauty trends are evolving faster than ever — and in 2026, it’s all about personalization, softness, and statement details. Modern brides are blending traditional elegance with contemporary aesthetics, creating hairstyles that look stunning both in real life and on camera."
},
  {
  id: 36,
  author: "Libra Events Blog Team",
  date: "17-02-2026",
  title: "Best Marriage Dates in 2026 – Auspicious Hindu Wedding Dates",
  slug: "best-marriage-dates-2026-auspicious-hindu-wedding-dates",
  image: blog36,
  snippet: "Planning your wedding in 2026? One of the first and most important steps is choosing an auspicious wedding date. In Hindu traditions, marriage dates are often selected based on the Hindu calendar, planetary positions, and muhurat timings to ensure prosperity, happiness, and harmony in married life."
},
  {
  id: 35,
  author: "Libra Events Blog Team",
  date: "15-02-2026",
  title: "The Best Honeymoon Weather by Wedding Month: Plan Yours!!",
  slug: "best-honeymoon-weather-by-wedding-month-2026",
  image: blog35,
  snippet: "Planning your honeymoon isn’t just about picking a destination — timing is everything. The weather during your honeymoon can completely shape your experience, from beach sunsets to snowy mountain escapes."
},
  {
  id: 34,
  author: "Libra Events Blog Team",
  date: "11-02-2026",
  title: "The Trending 2026 Haldi Aesthetic: Powder Blue!",
  slug: "powder-blue-haldi-theme-vadodara-2026",
  image: blog34,
  snippet: "Move over yellow and marigold — 2026 weddings are embracing a fresh, dreamy twist on Haldi décor. The latest wedding trend taking over Instagram and luxury celebrations is the Powder Blue Haldi aesthetic. Soft, elegant, and unexpectedly refreshing, this pastel palette is redefining traditional Haldi ceremonies with a modern touch."
},

  {
  id: 33,
  author: "Libra Events Blog Team",
  date: "09-02-2026",
  title: "55+ Best Sangeet Songs For Bridesmaids To Dance On In 2026!",
  slug: "55-best-sangeet-songs-for-bridesmaids-2026",
  image: blog33,
  snippet: "Sangeet nights are no longer just about the bride and groom — bridesmaids are stealing the spotlight with high-energy performances, emotional surprises, and viral choreography. Whether it’s a best friend performance, sister squad dance, or a full bridesmaid group act, the right song can make the moment unforgettable.",
},

{
  id: 32,
  date: "07-02-2026",
  title: "No More Same Old Sangeet: 80+ Bridal Solo Songs With a Twist",
  author: "Libra Events Blog Team",
  slug: "80-bridal-solo-songs-sangeet-vadodara",
  image: blog32,
  snippet: "The Sangeet ceremony has evolved from a simple pre-wedding function into a full-blown celebration of music, dance, and personality. Today’s brides want more than the usual choreography — they want performances that reflect their journey, emotions, and individuality. If you’re planning your bridal entry or solo Sangeet performance, it’s time to ditch the overused tracks and explore songs that bring freshness, drama, and impact."
},

{
  id: 31,
  title: "Looking for the Perfect Wedding Hall in Vadodara? Here’s What You Need to Know",
  author: "Libra Events Blog Team",
  date: "05-02-2026",
  image: blog31, // import image at top
  slug: "looking-for-the-perfect-wedding-hall-in-vadodara",
  snippet:'Planning a wedding is exciting—but choosing the right wedding hall in Vadodara can feel overwhelming. From guest capacity and décor to location and services, every detail matters when you’re planning one of the most important days of your life.'
  
},

  {
  id: 30,
  date: '12-01-2026',
  title: 'Themed Birthday Parties That Everyone Will Remember',
  slug: 'themed-birthday-parties-everyone-will-remember',
  image: blog30,
  snippet: 'A birthday party is more than just a celebration—it’s an experience that creates lasting memories. Themed birthday parties have become increasingly popular because they bring creativity, excitement, and a unique identity to the celebration. With the right theme, décor, and planning, a birthday party can truly stand out and be remembered by guests of all ages.'
},

  {
  id: 29,
  date: '09-01-2026',
  title: 'Latest Corporate Event Themes for 2025–2026',
  slug: 'latest-corporate-event-themes-2025-2026',
  image: blog29,
  snippet: 'Corporate events in 2025–2026 are evolving beyond traditional formats to become immersive brand experiences. Companies now focus on visual storytelling, guest engagement, and brand alignment while maintaining professionalism. From technology-driven concepts to sustainable décor ideas, the latest corporate event themes are designed to impress, inspire, and connect.'
},
  {
  id: 28,
  date: '07-01-2026',
  title: 'How to Choose the Perfect Wedding Decor Style Based on Your Venue Layout',
  slug: 'choose-perfect-wedding-decor-style-venue-layout',
  image: blog28,
  snippet: 'Choosing the right wedding décor is not just about colors and flowers—it’s about how well the décor complements your venue layout. A beautifully designed décor theme that doesn’t suit the space can feel overcrowded or underwhelming. The key to a stunning wedding setup lies in aligning your décor style with the structure, size, and flow of your venue.'
},

  {
  id: 27,
  date: '22-12-2025',
  title: 'How Far in Advance Should You Book an Event Planner? – Complete Guide',
  slug: 'how-far-in-advance-book-event-planner',
  image: blog27,
  snippet: 'Planning an event—whether it’s a wedding, birthday celebration, corporate seminar, or a private gathering—requires careful coordination. One of the most important decisions is when to book an event planner. Booking too late can limit your décor options, increase costs, and reduce availability, especially during peak seasons.'
},

  {
  id: 26,
  date: '19-12-2025',
  title: '5 Ways Lighting Design Transforms Your Event at the Best Banquet Hall in Manjalpur, Vadodara',
  slug: '5-ways-lighting-design-transforms-event-manjalpur-vadodara',
  image: blog26,
  snippet: 'When planning a memorable celebration, décor and venue matter—but lighting design is what truly brings an event to life. At Libra Events & Decorators, recognized as the Best Banquet Hall in Manjalpur, Vadodara, professional lighting transforms ordinary gatherings into unforgettable experiences.'
},

  {
  id: 25,
  date: '17-12-2025',
  title: '10 Event Decoration Ideas for Your Next Event in Vadodara',
  slug: '10-event-decoration-ideas-vadodara',
  image: blog25,
  snippet: 'Event decoration plays a vital role in creating unforgettable experiences. Whether you are planning a wedding, engagement, birthday party, baby shower, or corporate event, the right décor transforms your celebration into a visually stunning and memorable occasion. At Libra Events & Decorators, known as the Best Banquet Hall in Manjalpur, Vadodara, every event is designed with creativity, elegance, and precision.'
},

  {
  id: 24,
  date: '15-12-2025',
  title: 'Best Banquet Hall in Manjalpur, Vadodara | Libra Events & Decorators',
  slug: 'best-banquet-hall-manjalpur-vadodara-libra-events',
  image: blog24,
  snippet: 'Libra Events & Decorators is a trusted name and the best banquet hall in Manjalpur, Vadodara, offering premium event spaces and professional decoration services for all types of celebrations. Located at Eva Banquets, this venue is ideal for weddings, engagements, birthday parties, baby showers, and corporate events.'
},

  {
  id: 23,
  date: '12-12-2025',
  title: 'Top Reasons to Choose a Local Event Planner in Vadodara',
  slug: 'top-reasons-local-event-planner-vadodara',
  image: blog23,
  snippet: 'Planning an event—whether it’s a wedding, engagement, birthday party, corporate function, or cultural celebration—requires expertise, coordination, and attention to detail. While many people consider hiring planners from bigger cities, choosing a local event planner in Vadodara offers unique advantages that can make your event smoother, more personalized, and more cost-effective.'
},

  {
  id: 22,
  date: '10-12-2025',
  title: 'The Evolution of Event Decoration in Vadodara: 2015–2025',
  slug: 'evolution-event-decoration-vadodara-2015-2025',
  image: blog22,
  snippet: 'Over the last decade, event decoration in Vadodara has transformed from simple stage setups to immersive, Instagram-ready experiences. From traditional wedding décor to corporate events and themed parties, the city has embraced creativity, technology, and personalization like never before.'
},

  {
  id: 21,
  date: '08-12-2025',
  title: 'Best Indoor Wedding Themes for Venues in Manjalpur, Vadodara',
  slug: 'best-indoor-wedding-themes-manjalpur-vadodara',
  image: blog21,
  snippet: `Best Indoor Wedding Themes for Venues in Manjalpur, Vadodara Planning an indoor wedding in Vadodara? Manjalpur has become one of the most preferred wedding locations thanks to its modern venues, premium banquet halls, and professional event decorators.`
},

  {
  id: 20,
  date: '05-12-2025',
  title: 'Why Manjalpur Is Becoming the Top Choice for Weddings in Vadodara',
  slug: 'why-manjalpur-top-choice-weddings-vadodara',
  image: blog20,
  snippet: 'When couples begin searching for the Best Banquet Hall in Manjalpur, Vadodara, one thing becomes clear—Manjalpur is quickly growing into the most preferred wedding destination in the city. With stunning venues, easy connectivity, modern amenities, and professional event services, this locality has transformed into a wedding hotspot.'
},
  {
  id: 19,
  date: '03-12-2025',
  title: 'Checklist to Follow Before Booking a Banquet Hall in Vadodara',
  slug: 'checklist-before-booking-banquet-hall-vadodara',
  image: blog19,
  snippet: 'Finding the perfect banquet hall is a crucial step toward planning a successful event. Whether you’re preparing for a wedding, birthday celebration, engagement, baby shower, or a corporate meeting, choosing the right venue can make or break the occasion. If you’re specifically looking for the Best Banquet Hall in Manjalpur, Vadodara, this checklist will help you make the right decision with confidence.'
},
    {
    id: 18,
    date: '01-12-2025',
    title: 'How Libra Events Turns Birthday Parties into Magical Celebrations | Best Banquet Hall in Manjalpur, Vadodara',
    slug: 'birthday-parties-magical-celebrations-vadodara',
    image: blog18,
    snippet: 'Every birthday is a milestone — whether it’s a child’s first birthday, a sweet sixteen, an elegant adult celebration, or a surprise party that becomes a core memory. The décor, mood, and experience play a huge role in making the day truly unforgettable.'
  },

    {
    id: 17,
    date: '28-11-2025',
    title: 'Elevate Your Brand Image with Libra Events’ Corporate Event Styling | Best Banquet Hall in Manjalpur, Vadodara',
    slug: 'corporate-event-styling-vadodara',
    image: blog17,
    snippet: 'Corporate events are more than just gatherings — they are an opportunity to communicate your brand’s values, culture, and professionalism. Whether it’s an annual meet, award ceremony, conference, product launch, or client networking event, the way your event looks plays a major role in shaping brand perception.'
  },

    {
    id: 16,
    date: '26-11-2025',
    title: 'Simple Yet Stunning Wedding Themes for Every Couple | Best Banquet Hall in Manjalpur, Vadodara',
    slug: 'simple-stunning-wedding-themes-vadodara',
    image: blog16,
    snippet: 'Planning a wedding doesn’t have to feel overwhelming, especially when it comes to choosing the perfect theme. Sometimes, the most memorable weddings are the ones that keep things simple yet elegant. In 2025, couples in Vadodara are loving décor styles that balance beauty, emotion, and personalization — without excessive complexity.'
  },

    {
    id: 15,
    date: '24-11-2025',
    title: 'How to Create Instagram-Worthy Wedding Moments with Libra Events | Best Banquet Hall in Manjalpur, Vadodara',
    slug: 'instagram-worthy-wedding-moments-vadodara',
    image: blog15,
    snippet: 'Today’s weddings are not just ceremonies — they are experiences designed to be remembered, shared, and celebrated. With social media becoming an essential part of celebrations, couples now look for ways to create Instagram-worthy wedding moments that capture beauty, emotion, and aesthetics.'
  },
    {
    id: 14,
    date: '21-11-2025',
    title: 'Indoor Wedding Décor Ideas Perfect for Vadodara’s Weather | Best Banquet Hall in Manjalpur, Vadodara',
    slug: 'indoor-wedding-decor-ideas-vadodara',
    image: blog14,
    snippet: 'Indoor weddings are becoming increasingly popular in Vadodara, especially due to unpredictable weather and the growing demand for elegant, climate-controlled venues. Hosting your ceremony or reception indoors allows for greater creative freedom, better comfort, and a more refined atmosphere. When celebrated at the best banquet hall in Manjalpur, Vadodara, the experience becomes even more memorable.'
  },

    {
    id: 13,
    date: '19-11-2025',
    title: 'The Ultimate Wedding Décor Checklist for 2025 Brides | Best Banquet Hall in Manjalpur, Vadodara',
    slug: 'ultimate-wedding-decor-checklist-2025-vadodara',
    image: blog13,
    snippet: `Planning wedding décor can feel overwhelming, especially with the evolving trends of 2025. From color themes and lighting to floral arrangements and personalized installations, every detail plays a role in creating your dream celebration.`
  },

    {
    id: 12,
    date: '17-11-2025',
    title: 'How Libra Events Adds a Personal Touch to Every Wedding in Vadodara',
    slug: 'how-libra-events-adds-personal-touch-wedding-vadodara',
    image: blog12,
    snippet: 'A wedding is one of the most meaningful moments in a couple’s life. It represents their journey, emotions, families, and the beginning of a new chapter. At Libra Events & Decorators, Vadodara, we believe every wedding should feel personal, emotional, and beautifully tailored to the couple’s unique story.'
  },

    {
    id: 11,
    date: '14-11-2025',
    title: 'The Secret to Stunning Wedding Decorations on Any Budget | Best Banquet Hall in Manjalpur, Vadodara',
    slug: 'secret-to-stunning-wedding-decorations-vadodara',
    image: blog11,
    snippet: 'A wedding is one of life’s most beautiful milestones — and it deserves to look spectacular without costing a fortune. The good news? You don’t need an extravagant budget to make your wedding venue look elegant and memorable.'
  },
    {
    id: 10,
    date: '05-11-2025',
    title: 'Transform Your Wedding Venue into a Fairytale with Libra Events Vadodara',
    slug: 'transform-wedding-venue-fairytale-vadodara',
    image: blog10,
    snippet: 'Every couple dreams of a wedding that feels straight out of a fairytale — breathtaking décor, magical lighting, elegant setups, and an ambiance that reflects love and joy. At Libra Events & Decorators, we bring those dreams to life with creativity, precision, and a touch of luxury. As one of the best wedding decorators in Vadodara, we specialize in transforming ordinary venues into extraordinary experiences.'
  },

    {
    id: 9,
    date: '20-10-2025',
    title: "Planning a Corporate Diwali Party in Vadodara? Here's What You Need to Know",
    slug: 'planning-corporate-diwali-party-vadodara',
    image: blog9,
    snippet: "With Diwali just around the corner, Vadodara's corporate world is buzzing with plans to celebrate the festival of lights. A well-organized corporate Diwali party is more than just a celebration; it's a powerful tool to foster team spirit, express gratitude to employees, and strengthen client relationships."
  },
    {
    id: 8,
    date: '17-10-2025',
    title: 'How to Host a Flawless Corporate Diwali Party in Vadodara',
    slug: 'how-to-host-corporate-diwali-party-vadodara',
    image: blog8,
    snippet: `Diwali is more than just a festival; in the corporate world, it's a golden opportunity to strengthen bonds, show appreciation, and celebrate shared success. A well-executed Corporate Diwali Party in Vadodara can significantly boost employee morale, impress clients, and reinforce your company's positive culture.`
  },
    {
    id: 7,
    date: '16-10-2025',
    title: 'Host a Stress-Free Diwali Party in Vadodara with Libra Events',
    slug: 'host-stress-free-diwali-party-vadodara',
    image: blog7,
    snippet: 'The festival of lights is just around the corner, and the excitement of celebrating Diwali with friends and family is in the air! While hosting a Diwali party can be a joyous occasion, the planning, decorating, and organizing can often feel overwhelming. But what if you could host a spectacular Diwali bash without the stress?'
  },
    {
    id: 6,
    date: '09-10-2025',
    title: 'Finding the Best Event Planner in Vadodara | Your Ultimate 2025 Guide',
    slug: 'finding-best-event-planner-vadodara',
    image: blog6,
    snippet: `Planning an event in the vibrant city of Vadodara, with its rich culture and beautiful venues, should be exciting. However, turning your dream celebration—be it a lavish wedding, a professional corporate event, or a chic birthday party—into reality can quickly become overwhelming.`
  },

    {
    id: 5,
    date: '23-09-2025',
    title: 'Birthday Party Decoration Ideas That Make Memories Last',
    slug: 'birthday-party-decoration-ideas-memories',
    image: blog5,
    snippet: 'A birthday is more than just a date on the calendar—it’s a celebration of life, love, and memories. Whether it’s your child’s first birthday, a sweet sixteen, or a milestone 50th, the right décor can transform the occasion into something unforgettable.'
  },  
  {
    id: 4,
    date:'15-09-2025',
    title: 'How to Choose the Right Event Management Company in Vadodara', 
    slug: 'how-to-choose-right-event-management-company-vadodara', 
    image: blog4, 
    snippet: 'Planning a memorable event in Vadodara? Choosing the best event management company in Vadodara can make all the difference for a flawless and stress-free experience. At Libra Events & Decorators, located at Eva Banquets, Manjalpur, Vadodara, we specialize in creating breathtaking wedding decor, corporate events, and themed parties that leave a lasting impression.'
  },
  {
    id: 3,
    date:'10-09-2025',
    title: 'Why Libra Events & Decorators is the Best Choice for Wedding Decor in Vadodara', 
    slug: 'why-libra-events-best-wedding-decor-vadodara', 
    image: blog3, 
    snippet: 'When couples imagine their wedding day, they often think of the lights, flowers, colors, and the magical setting that will make the celebration unforgettable. To bring that vision to life, you need the best wedding decorators in Vadodara—professionals who understand both tradition and modern trends.'
  },
  {
    id: 2,
    date:'02-09-2025',
    title: 'Step-by-Step Guide to Planning the Perfect Corporate Event in Vadodara', 
    slug: 'step-by-step-guide-corporate-event-vadodara', 
    image: blog2, 
    snippet: 'Corporate events are a powerful tool, especially for dynamic businesses in thriving areas like Manjalpur, Vadodara. They can be used to launch a new product, celebrate a milestone, or build stronger teams.'
  },
  {
    id: 1,
    date:'19-08-2025',
    title: 'Why Hire a Professional Event Decorator?', 
    slug: 'why-hire-a-professional-event-decorator', 
    image: blog1, 
    snippet: 'When planning a big celebration or milestone, every detail counts. From weddings and corporate events to birthdays and anniversaries, the decor sets the tone and creates lasting memories.'
  }
];

const BlogList = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <div className="blog-page-wrapper">
      <Header />

      <section className="blog-hero-section" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="blog-hero-overlay container">
          <h1 className="blog-hero-title">
            Our <span className="blog-highlight">Blog</span>
          </h1>
          <div className="blog-breadcrumbs mt-3">
            <a href='/' className="blog-home-link">
              <span className="blog-home">Home</span>
            </a>
            <span className="blog-divider"> | </span>
            <span className="blog-current-page">Blog</span>
          </div>
        </div>
      </section>

      <div className="blog-list-container">
        <h1 className="blog-list-heading">Our Blog</h1>
        <div className="blog-card-grid">
          {blogPosts.map(post => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default BlogList;
